/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { FormattedHTMLMessage } from 'react-intl';
import ReactTooltip from 'react-tooltip'

// Messages
import messages from './messages/UserNavItem_messages';

// Styles
import './styles/UserNavItem.scss';

const propTypes = {
  history: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  actions: PropTypes.array.isRequired,
};

class UserNavItem extends PureComponent {
  state = {
    hideDropdown: true,
    ytunnus: '',
  };

  _handleActionClick = action => {
    this.setState({ hideDropdown: true });
    action();
  };

  _handleNavigation = event => {
    event.preventDefault();

    const { history } = this.props;
    const { ytunnus } = this.state;
    history.push(`/selvitys/FI/${ytunnus}/dashboard`);

    this.setState({ hideDropdown: true, ytunnus: '' });
  };

  _handleYtunnusChange = event => {
    const { value } = event.target;
    this.setState({ ytunnus: value });
  };

  _renderAction = ({ label, action }, key) => {
    const onClickHandler = this._handleActionClick.bind(this, action);
    return (
      <li onClick={onClickHandler} key={key}>
        {label}
      </li>
    );
  };

  _toggleActions = () => {
    this.setState({ hideDropdown: !this.state.hideDropdown });
  };

  get showLicenseManagement() {
    const { user } = this.props;
    const ALLOWED = ['license_retailer', 'license_admin', 'super_user'];

    if (user.super_user) {
      return true;
    }
    const accessLevels = user.access_levels.filter(
      al => ALLOWED.indexOf(al) !== -1
    );
    if (accessLevels.length > 0) {
      return true;
    }
    return false;
  }

  render() {
    const { user, actions } = this.props;
    const { hideDropdown, ytunnus } = this.state;

    const username = user.username.length <= 15
      ? user.username
      : `${user.username.substr(0, 12)}...`;

    return (
      <div styleName="UserNavItem">
        <div
          styleName="user-box"
          onClick={this._toggleActions}
          data-tip={user.username}
        >
          <i className="fa fa-user" />
          <strong>{username}</strong>
        </div>

        {!hideDropdown && (
          <div styleName="actions-dropdown">
            <ul>
              {actions.map(this._renderAction)}

              {this.showLicenseManagement && (
                <React.Fragment>
                  <hr />
                  <li>
                    {/* eslint-disable jsx-a11y/anchor-is-valid */}
                    <Link to='/lisenssit'>Lisenssihallinta</Link>
                    {/* eslint-enable jsx-a11y/anchor-is-valid */}
                  </li>
                  <li>
                    <form onSubmit={this._handleNavigation}>
                      <input
                        type="text"
                        placeholder="Y-tunnus"
                        onChange={this._handleYtunnusChange}
                        value={ytunnus}
                      />

                      <button type="submit">
                        <FormattedHTMLMessage {...messages.navigateYtunnus} />
                      </button>
                    </form>
                  </li>
                </React.Fragment>
              )}
            </ul>
          </div>
        )}
        <ReactTooltip place="bottom" effect="solid" />
      </div>
    );
  }
}

UserNavItem.propTypes = propTypes;

export default UserNavItem;
